export const TRANSPORTS_REDUCER = 'transports'
export const JOURNEYS_BY_TENANT_ID_REDUCER_NAME = 'journeys'
export const TRANSPORTS_LEG_BY_ID_REDUCER_NAME = 'transportsLegById'
export const TRANSPORTS_LOADS_REDUCER_NAME = 'transportsLoads'
export const TRANSPORTS_EMPLOYEE_REDUCER_NAME = 'transportsEmployee'
export const TRANSPORTS_ASSETS_REDUCER_NAME = 'transportsAssets'
export const TRANSPORTS_ASSETS_CONFIGURATION_REDUCER_NAME = 'transportsAssetConfigurations'
export const LOADING = 'loading'
